export var formatNumber = function formatNumber(val, decimals) {
  var num = val - 0;
  var strNum = val;
  if (num && num >= 100000000) {
    strNum = (num / 100000000).toFixed(1) + "亿";
  } else if (num && num >= 10000) {
    strNum = (num / 10000).toFixed(1) + "万";
  } else {
    strNum = !num ? val + "" : num.toFixed(decimals);
  }
  return strNum.split(".");
};
export var jsonpRequest = function jsonpRequest(_ref) {
  var url = _ref.url,
    callbackParamName = _ref.callbackParamName;
  return jsonp(url, {
    jsonpCallback: callbackParamName // optional, 'callback' by default
  }).then(function (res) {
    return res.json();
  })["catch"](function (err) {
    console.log("[jsonpRequest] catch Error: " + url, false, 400, "Sys Error", "errors: " + JSON.stringify(err));
  });
};
export var convertBuyerTags = function convertBuyerTags(tags) {
  var res = {
    jiaGeLi: false,
    shangPinLi: false,
    chanDi: false
  };
  tags.map(function (tag) {
    if (tag.tagType1 === "价格力") {
      res.jiaGeLi = true;
    } else if (tag.tagType1 === "商品力") {
      res.shangPinLi = true;
    } else if (tag.tagType1 === "产地") {
      res.chanDi = true;
    }
  });
  return res;
};
export var convertOfferTags = function convertOfferTags(tags) {
  var res = {
    jiaGeLi: {
      isJiaGeLi: false,
      txt: ""
    },
    shangPinLi: {
      isShangPinLi: false,
      baoPin: false,
      xinPin: false,
      yanXuan: false
    },
    chanDi: {
      isChanDi: false,
      location: ""
    }
  };
  tags.map(function (tag) {
    if (tag.tagType1 === "商品力") {
      res.shangPinLi.isShangPinLi = true;
      if (tag.tagType2 === "爆品") {
        res.shangPinLi.baoPin = true;
      } else if (tag.tagType2 === "新品") {
        res.shangPinLi.xinPin = true;
      } else if (tag.tagType2 === "严选") {
        res.shangPinLi.yanXuan = true;
      }
    } else if (tag.tagType1 === "价格力") {
      res.jiaGeLi.isJiaGeLi = true;
      if (tag.tagName === "价格力") {
        res.jiaGeLi.txt = "真实低价";
      } else {
        res.jiaGeLi.txt = tag.tagName;
      }
    } else if (tag.tagType1 === "产地") {
      res.chanDi.isChanDi = true;
      res.chanDi.location = tag.value;
    }
  });
  return res;
};